/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RestructuringWorkflowSettingsLight {
  name?: string | null;
  assignedState?: RestructuringWorkflowSettingsLightAssignedStateEnum;
  isStateRevert?: boolean;
  isSubStateRevert?: boolean;
  isStateForward?: boolean;
  isSubStateForward?: boolean;
}
export enum RestructuringWorkflowSettingsLightAssignedStateEnum {
  Draft = 'Draft',
  Monitoring = 'Monitoring',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Published = 'Published'
}
